import { THEMES } from 'src/constants';
import { createCustomTheme } from 'src/theme';

/**
 * The wall screens run the app's dark theme on a deeper, blue-tinted navy: an idle screen glowing
 * across an office should be calm, and the brand blue is lifted so it holds contrast on it.
 */
export const TV_COLORS = {
  background: '#0B1520',
  line: 'rgba(158, 190, 220, 0.16)',
  text: '#EEF3F8',
  muted: '#93A7BC',
  accent: '#4BA3DE',
  warning: '#F2B35B',
  /** A goal reached. The only green on the screen, so it keeps its meaning. */
  win: '#46D78A',
};

/**
 * The leaderboard's top six, bright to dim green like the sheets the screens replace. `text` keeps
 * the rank number readable on each step (navy on the light greens, white on the dark ones).
 */
export const TV_PODIUM = [
  { fill: '#46D78A', text: '#0B1520' },
  { fill: '#3BBE78', text: '#0B1520' },
  { fill: '#33A468', text: '#0B1520' },
  { fill: '#2D8A59', text: '#0B1520' },
  { fill: '#27704A', text: '#EEF3F8' },
  { fill: '#22573C', text: '#EEF3F8' },
];

export const tvTheme = createCustomTheme({
  theme: THEMES.DARK,
  themeAdditionalOptions: {
    [THEMES.DARK]: {
      palette: {
        background: { default: TV_COLORS.background, paper: TV_COLORS.background },
        text: { primary: TV_COLORS.text, secondary: TV_COLORS.muted },
        divider: TV_COLORS.line,
      },
    },
  },
});
